"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/appSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AppSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/app-store.svg" | "/Templates/Doccure/img/icons/google-play.svg" */
    src: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "img" */
    alt?: string;
};
export type HomeOneAppSectionGeneratedProps = {
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: AppSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Download the Doccure App today!" */
    sectionDiv0Div0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Working for Your Better Health." */
    sectionDiv0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "img" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/mobile-img.png" */
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/app-bg-02.png" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv0Div0Div1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/app-bg-03.png" */
    sectionDiv0Div0Div1ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    sectionDiv0Div0Div1ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/app-bg-04.png" */
    sectionDiv0Div0Div1ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    appSectionDivs: AppSectionDivsItem[];
    appSectionDivsItemWrapper?: (item: AppSectionDivsItem, content: ReactNode) => ReactNode;
    appSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    appSectionDivsLinkVisible?: boolean;
    appSectionDivsLinkRenderer?: (item: AppSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    appSectionDivsImageVisible?: boolean;
    appSectionDivsImageRenderer?: (item: AppSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    appSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: AppSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    appSectionDivsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AppSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeOneAppSectionGenerated: FC<HomeOneAppSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Div0Div0H20H2Text = "Download the Doccure App today!",
    sectionDiv0Div0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0Div0Div0P0PText = "Working for Your Better Health.",
    sectionDiv0Div0Div0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "img",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/mobile-img.png",
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt = "img",
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/app-bg-02.png",
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1ImageWithBasePath1ImageAlt = "img",
    sectionDiv0Div0Div1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/app-bg-03.png",
    sectionDiv0Div0Div1ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1ImageWithBasePath2ImageAlt = "img",
    sectionDiv0Div0Div1ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/app-bg-04.png",
    sectionDiv0Div0Div1ImageWithBasePath2ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath2ImageProps,
    linkImageWithBasePath0ImageProps,
    linkLinkProps,
    sectionDiv0Div0Div0ClassName,
    appSectionDivs,
    appSectionDivsItemWrapper,
    appSectionDivsRenderer,
    appSectionDivsLinkVisible,
    appSectionDivsLinkRenderer,
    appSectionDivsImageVisible,
    appSectionDivsImageRenderer,
    appSectionDivsLinkProps,
    appSectionDivsImageProps,
}) => {
    return (
        <section className="app-section app-sec-one p-0">
            <div className="container">
                <div className="app-bg">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row"}>
                        <div className="col-lg-6 col-md-12">
                            <div className="app-content d-flex flex-column justify-content-center">
                                <div className="section-header section-header-one wow zoomIn" data-wow-duration={sectionDiv0Div0Div0Div0Div0Div0DivDataWowDuration}>
                                    <p className="mt-0 mb-0">{sectionDiv0Div0Div0Div0Div0Div0P0PText}</p>
                                    {renderNode(sectionDiv0Div0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0Div0H20H2Props ?? {})}>
                                            {" "}
                                            {sectionDiv0Div0Div0Div0Div0Div0H20H2Text}
                                            {" "}
                                        </h2>
                                    ))}
                                </div>
                                <div className="google-imgs wow fadeOutDown" data-wow-duration={sectionDiv0Div0Div0Div0Div0Div1DivDataWowDuration}>
                                    {renderCollectionNode(
                                        appSectionDivs,
                                        (item: AppSectionDivsItem) => (
                                            renderItemNode(appSectionDivsLinkVisible, appSectionDivsLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof appSectionDivsLinkProps === "function" ? appSectionDivsLinkProps(item) : (appSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    {renderItemNode(appSectionDivsImageVisible, appSectionDivsImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof appSectionDivsImageProps === "function" ? appSectionDivsImageProps(item) : (appSectionDivsImageProps ?? {}))} {...(typeof linkImageWithBasePath0ImageProps === "function" ? linkImageWithBasePath0ImageProps(item) : (linkImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </SmartLink>
                                            ))
                                        ),
                                        appSectionDivsItemWrapper,
                                        appSectionDivsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 wow fadeOutDown" data-wow-duration={sectionDiv0Div0Div0Div1DivDataWowDuration}>
                            <div className="mobile-img">
                                {renderNode(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="app-bgs">
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath0ImageAlt} className="app-bg-01" {...(sectionDiv0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath1ImageAlt} className="app-bg-02" {...(sectionDiv0Div0Div1ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath2ImageVisible, sectionDiv0Div0Div1ImageWithBasePath2ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath2ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath2ImageAlt} className="app-bg-03" {...(sectionDiv0Div0Div1ImageWithBasePath2ImageProps ?? {})} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeOneAppSectionGenerated;
